module.exports = require("@soda/get-current-script");